export default function getObjectUtil (object, path, defaultValue) {
  if (path == null) {
    path = ''
  }

  if (typeof path === 'number') {
    path += ''
  }

  // If the path is a string, convert it to an array
  if (typeof path === 'string') {
    path = path.split('.').map(key => key.replace(/\[(\d+)\]/g, '.$1')).join('.').split('.')
  }

  // Traverse the object using the path array
  let result = object
  for (let i = 0; i < path.length; i++) {
    if (result === undefined || result === null) {
      return defaultValue
    }
    result = result[path[i]]
  }

  // If the result is undefined, return the default value
  return result === undefined
    ? defaultValue
    : result
}
